import {
    Typography, Button, Icon, Box,
    CardActions, CardContent, CardMedia
} from '@mui/material'

import { useNavigate } from 'react-router-dom'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES_ID_MODE } from '@features/routes'

import Tile from '@components/Tile'

import azureLogo from './media/azureLogo.png'
import awsLogo from './media/awsLogo.png'

export const LzCard = (props) => {
    let logo = azureLogo
    if (props.azure) logo = azureLogo
    if (props.aws) logo = awsLogo

    const navigate = useNavigate()

    const handleMigration = () => {
        if (props.needMigration && props.subscription && !props.aws)
            navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, {id: props.id, mode: 'firewall-migration'}))
    }

    const handleSettings = () => {
        if (props.id) navigate(generateUrl(ROUTE_LANDING_ZONES_ID_MODE, {id: props.id, mode: 'groups'}))
    }

    return (
        <Tile sx={{width: '240px', padding: 0}}>
            <Box onClick={handleSettings} sx={{cursor: 'pointer'}}>
                <CardMedia
                    sx={{borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}}
                    component={'img'}
                    alt={props.id}
                    height={'140'}
                    image={logo}
                />
                <CardContent>
                    <Typography variant="h4">{props.id}</Typography>
                </CardContent>
            </Box>
            {!props.aws && (
                <CardActions sx={{paddingBottom: '16px'}}>
                    {props.needMigration && (
                        <Button variant={'secondary'} onClick={handleMigration} startIcon={<Icon>sync_alt</Icon>} sx={{width: '100%'}}>
                            Firewall migration
                        </Button>
                    )}
                </CardActions>
            )}
        </Tile>
    )
}

export default LzCard